(function () {
    'use strict';

    function parseConstantExpr($parse, context, name, expression, fallback) {
        if (angular.isDefined(expression)) {
            var parseFn = $parse(expression);
            if (!parseFn.constant) {
                /*global minErr*/
                throw minErr('ngModel')('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                    '`{1}`.', name, expression);
            }
            return parseFn(context);
        }
        return fallback;
    }


    angular.module('doclr.components.util', [])
        .service('ConstantExpressionParser', function () {
            return parseConstantExpr;
        })
        .factory('DoclrHttp', function ($http, AppConfigService) {
            return {
                get: get,
                post: post,
                put: put,
                delete: del,
            };

            function get(url, params) {
                let config = {
                    method: 'GET',
                    url: setApiUrlIfNotPresent(url)
                };
                if (params) {
                    config.params = params;
                }
                return $http(config)
                    .then((response) => response.data);
            }

            function post(url, params) {
                return $http.post(setApiUrlIfNotPresent(url), params)
                    .then((response) => response.data);
            }

            function put(url, params) {
                return $http.put(setApiUrlIfNotPresent(url), params)
                    .then((response) => response.data);
            }

            function del(url) {
                return $http.delete(setApiUrlIfNotPresent(url))
                    .then((response) => response.data);
            }

            function setApiUrlIfNotPresent(url) {
                if (url.indexOf('http') === -1) {
                    return AppConfigService.getApiUrl() + url;
                }
                return url;
            }
        })
        .factory('repeater', function ($interval) {
            var runningItems = [];

            function createItem(fn) {
                var timer;
                return {
                    start: function () {
                        if (!timer) {
                            if (this.immediate) {
                                fn();
                            }
                            timer = $interval(fn, this.interval || 300 * 1000);
                            runningItems.push(this);
                        }
                        return this;
                    },
                    stop: function () {
                        if (timer) {
                            $interval.cancel(timer);
                            timer = null;
                            runningItems.splice(runningItems.indexOf(this), 1);
                        }
                        return this;
                    },
                    restart: function () {
                        return this.stop().setImmediate(true).start();
                    },
                    limitTo: function ($scope) {
                        var self = this;
                        $scope.$on('$destroy', function () {
                            self.stop();
                        });
                        return this;
                    },
                    assignName: function (name) {
                        this.name = name;
                        return this;
                    },
                    setInterval: function (interval) {
                        this.interval = interval;
                        return this;
                    },
                    setImmediate: function (immediate) {
                        this.immediate = immediate;
                        return this;
                    }
                };
            }

            return {
                repeat: function (fn, interval) {
                    return createItem(fn, interval);
                },
                restart: function () {
                    var names = Array.prototype.slice.call(arguments);
                    var copiedRunningItems = runningItems.slice(0);
                    for (var i = 0; i < copiedRunningItems.length; i++) {
                        if (names.indexOf(copiedRunningItems[i].name) !== -1) {
                            copiedRunningItems[i].restart();
                        }
                    }
                }
            };
        })
        .filter('transform', function () {
            return function (value, transformation) {
                return transformation(value);
            };
        }).filter('idstring', function () {
        return function (str) {
            if (!str) {
                return str;
            }
            return str.replace(" ", "_")
                .toLowerCase();
        };
    })
        .factory('borderColor', function () {
            return function (baseColor) {
                /* jshint bitwise: false */
                var percent = -25;
                var num = parseInt(baseColor.slice(1), 16), amt = Math.round(2.55 * percent), R = (num >> 16) + amt,
                    G = (num >> 8 & 0x00FF) + amt, B = (num & 0x0000FF) + amt;
                return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
            };
        })
        .factory('lighterColor', function () {
            return function (baseColor, percent) {
                /* jshint bitwise: false */
                var num = parseInt(baseColor.slice(1), 16), amt = Math.round(2.55 * percent), R = (num >> 16) + amt,
                    G = (num >> 8 & 0x00FF) + amt, B = (num & 0x0000FF) + amt;
                return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
            };
        })
        .factory('csvDownloader', function () {

            return {
                download: download
            };

            function download(response, fileName) {
                const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
                const meFile = new Blob([BOM, response.data], {type: 'text/csv;charset=utf-8;', encoding: 'UTF-8'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;
                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(meFile));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                } else if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(meFile, fileName);
                } else {
                    window.open(URL.createObjectURL(meFile));
                }
            }
        })
        .factory('excelDownloader', function () {
            return {
                download: download
            };

            function download(response, fileName) {
                const file = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;
                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(file));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                } else if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                } else {
                    window.open(URL.createObjectURL(file));
                }
            }
        })
        .factory('pdfDownloader', function () {
            return {
                download: download
            };

            function download(response, fileName, stampType) {

                if (stampType === 'datetime') {
                    fileName = fileName + '-' + datetimestamper();
                }

                fileName = fileName + '.pdf';

                const file = new Blob([response.data], {type: 'application/pdf'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                // noinspection PointlessBooleanExpressionJS
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;

                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(file));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                    return;
                }
                if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                    return;
                }

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);

            }
        })
        .factory('wordDownloader', function () {
            return {
                download: download
            };

            function download(response, fileName, stampType) {

                if (stampType === 'datetime') {
                    fileName = fileName + '-' + datetimestamper();
                }

                fileName = fileName + '.docx';

                const file = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                // noinspection PointlessBooleanExpressionJS
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;

                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(file));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                    return;
                }
                if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                    return;
                }

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);

            }
        })
        .factory('zipDownloader', function () {

            return {
                download: download
            };

            function download(response, fileName, stampType) {

                if (stampType === 'datetime') {
                    fileName = fileName + '-' + datetimestamper();
                }

                fileName = fileName + '.zip';

                const file = new Blob([response.data], {type: 'application/zip'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                // noinspection PointlessBooleanExpressionJS
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;

                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(file));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                    return;
                }
                if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                    return;
                }

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);

            }
        })
        .directive('keypressEvents', [
            '$document',
            '$rootScope',
            function ($document, $rootScope) {
                return {
                    restrict: 'A',
                    link: function () {
                        // TODO linus: dit is een potentiële memory leak (momenteel wordt deze directive enkel op body gezet, en wordt deze directive niet gedestroyed)
                        // TODO linus: bovendien genereert deze directive te veel apply cycles

                        function broadcast(type, e) {
                            $rootScope.$apply(function () {
                                $rootScope.$broadcast(type, e);
                                $rootScope.$broadcast(type + ':' + e.which, e);
                            });
                        }

                        $(document).keypress(function (e) {
                            broadcast('keypress', e);
                        });
                        $(document).keydown(function (e) {
                            broadcast('keydown', e);
                        });
                        $(document).keyup(function (e) {
                            broadcast('keyup', e);
                        });
                        $(document).click(function (e) {
                            broadcast('click', e);
                        });

                    }
                };
            }
        ])
        .directive('showHideSidebar', [
            function () {
                return {
                    restrict: 'A',
                    template: '<span class="fa " ng-class="active ? \'fa-angle-double-right\' : \'fa-angle-double-left\'" style="display: block; height: 14px"></span>',
                    link: function ($scope, element) {
                        $scope.active = true;
                        element.click(function (e) {
                            e.preventDefault();
                            $('.page-with-sidebar').toggleClass('active');
                            $scope.$apply(function () {
                                $scope.active = !$scope.active;
                            });
                        });

                        $scope.$on('$destroy', function () {
                            element.off('click');
                        });
                    }
                };
            }
        ])
        .directive('defaultEnterAction', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, element) {
                    $scope.$on('keydown:13', function () {
                        $timeout(function () {
                            element.click();
                        }, 0, false);
                    });
                }
            };
        })
        .directive('preventDoubleClick', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, element) {
                    element.click(function () {
                        $timeout(function () {
                            element.attr('disabled', 'disabled');
                        }, 0, false);
                    });

                    $scope.$on('$destroy', function () {
                        element.off('click');
                    });
                }
            };
        })
        .directive('preventDoubleClickReEnable', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, element) {
                    element.click(function () {
                        $timeout(function () {
                            element.attr('disabled', 'disabled');
                            element.attr('reenable', 'reenable');
                        }, 0, false);

                        $timeout(function () {
                            if (element.attr('reenable') === 'reenable' && element.attr('disabled') === 'disabled') {
                                element.removeAttr('disabled');
                                element.removeAttr('reenable');
                            }
                        }, 2000, false);
                    });

                    $scope.$on('$destroy', function () {
                        element.off('click');
                    });
                }
            };
        })
        .directive('agendalist', function (praktijkContext, sortByProperty, DoclrModalService, localStorageService) {

            function groupAgendas(agendas) {

                const getPartyAddressName = (partyAddress) => partyAddress ? partyAddress.locatieNaam : "-";

                const distinct = (v, i, arr) => arr.indexOf(v) === i;

                const groupBy = (selector) => (groupedArray, item) => {
                    const possibleGroups = groupedArray.filter(group => selector(group[0]) === selector(item));

                    if (possibleGroups.length > 0) {
                        possibleGroups[0].push(item);
                    } else {
                        groupedArray.push([item])
                    }
                    return groupedArray;
                };

                let nbOfUniqueLocations = agendas.map(cal => getPartyAddressName(cal.partyAddress))
                    .filter(distinct)
                    .length;

                let nbOfUniqueDisciplines = agendas.map(cal => cal.disciplineName)
                    .filter(distinct)
                    .length;

                let legendItems = [];
                let groupedByLocation = agendas
                    .reduce(groupBy(cal => getPartyAddressName(cal.partyAddress)), [])
                    .sort(sortByProperty(group => group[0].partyAddress ? group[0].partyAddress.volgorde : 0));

                groupedByLocation.forEach(locationGroup => {
                    if (praktijkContext.meerdereLocaties && nbOfUniqueLocations > 1) {
                        legendItems.push({title: getPartyAddressName(locationGroup[0].partyAddress)});
                    }

                    let groupedByDiscipline = locationGroup
                        .reduce(groupBy(cal => cal.disciplineName), [])
                        .sort(sortByProperty(group => group[0].disciplineName ? group[0].disciplineName : 0));

                    groupedByDiscipline.forEach(disciplineGroup => {
                        if (nbOfUniqueDisciplines > 1) {
                            legendItems.push({
                                title: disciplineGroup[0].disciplineName,
                                clickableDiscipline: true,
                                calendarIds: disciplineGroup.map(cal => cal.id)
                            });
                        }

                        disciplineGroup
                            .sort(sortByProperty(cal => cal.volgnummer))
                            .forEach(calendar => {
                                legendItems.push({calendar: calendar});
                            });
                    });
                });
                return legendItems;
            }

            return {
                restrict: 'A',
                scope: {
                    agendas: '=',
                    onAgendaClicked: '&',
                    onAgendasClicked: '&',
                    onOnlyAgendaClicked: '&',
                    onAllClicked: '&',
                    onDisciplineAllClicked: '&',
                    selectedAgenda: '=',
                    selectedAgendas: '=',
                    discipline: '=',
                    header: '=',
                    all: '=',
                    savedViews: '=',
                    selectionActive: '=',
                    selectedResources: '=',
                    onApplySavedView: '&',
                    onUpdateSavedView: '&',
                    onAddSavedView: '&',
                    onRenameSavedView: '&',
                    onDeleteSavedView: '&'
                },
                templateUrl: '/partials/components/utils/agenda.list.html',
                replace: true,
                link: function (scope) {
                    scope.legendItems = groupAgendas(scope.agendas);

                    const buildLocationGroups = (items) => {
                        const groups = [];
                        let locationGroup = null;
                        let disciplineGroup = null;
                        let currentLocationCollapseKey = null;

                        items.forEach(item => {
                            if (item.title && !item.clickableDiscipline) {
                                item.collapseKey = item.title;
                                currentLocationCollapseKey = item.collapseKey;
                                locationGroup = {
                                    header: item,
                                    disciplineGroups: [],
                                    directCalendars: [],
                                    bodyCollapseKey: item.collapseKey
                                };
                                groups.push(locationGroup);
                                disciplineGroup = null;
                            } else if (item.title && item.clickableDiscipline) {
                                item.collapseKey = currentLocationCollapseKey ? currentLocationCollapseKey + '|' + item.title : item.title;
                                if (!locationGroup) {
                                    locationGroup = {
                                        header: null,
                                        disciplineGroups: [],
                                        directCalendars: [],
                                        bodyCollapseKey: '__root__'
                                    };
                                    groups.push(locationGroup);
                                }
                                disciplineGroup = {header: item, calendars: []};
                                locationGroup.disciplineGroups.push(disciplineGroup);
                            } else {
                                if (disciplineGroup) {
                                    disciplineGroup.calendars.push(item);
                                } else {
                                    if (!locationGroup) {
                                        locationGroup = {
                                            header: null,
                                            disciplineGroups: [],
                                            directCalendars: [],
                                            bodyCollapseKey: '__root__'
                                        };
                                        groups.push(locationGroup);
                                    }
                                    locationGroup.directCalendars.push(item);
                                }
                            }
                        });
                        return groups;
                    };

                    scope.locationGroups = buildLocationGroups(scope.legendItems);
                    scope.collapsedHeaders = {};
                    const storedState = localStorageService.getItem('lastViewState') || {};
                    (storedState.collapsedGroupTitles || []).forEach(t => {
                        scope.collapsedHeaders[t] = true;
                    });

                    const writeCollapsedToStorage = () => {
                        const current = localStorageService.getItem('lastViewState') || {};
                        localStorageService.storeItem('lastViewState', {
                            ...current,
                            collapsedGroupTitles: scope.getCollapsedTitles()
                        });
                    };

                    scope.toggleHeader = (key) => {
                        scope.collapsedHeaders[key] = !scope.collapsedHeaders[key];
                        writeCollapsedToStorage();
                    };
                    scope.isMainCollapsed = () => {
                        return scope.locationGroups.every(locationGroup => {
                            if (locationGroup.header && scope.collapsedHeaders[locationGroup.header.collapseKey]) return true;
                            if (!locationGroup.header && scope.collapsedHeaders['__root__']) return true;
                            if (locationGroup.directCalendars.length > 0) return false;
                            return locationGroup.disciplineGroups.every(dg => scope.collapsedHeaders[dg.header.collapseKey]);
                        });
                    };
                    scope.collapseAll = () => {
                        const locationHeaders = scope.locationGroups.filter(g => g.header);
                        if (locationHeaders.length > 0) {
                            locationHeaders.forEach(g => {
                                scope.collapsedHeaders[g.header.collapseKey] = true;
                            });
                        } else {
                            const allDisciplineGroups = scope.locationGroups.reduce((acc, g) => acc.concat(g.disciplineGroups), []);
                            if (allDisciplineGroups.length > 0) {
                                allDisciplineGroups.forEach(dg => {
                                    scope.collapsedHeaders[dg.header.collapseKey] = true;
                                });
                            } else {
                                scope.collapsedHeaders['__root__'] = true;
                            }
                        }
                        writeCollapsedToStorage();
                    };
                    scope.expandAll = () => {
                        scope.collapsedHeaders = {};
                        writeCollapsedToStorage();
                    };


                    scope.editingView = {};
                    scope.renameModel = {};
                    scope.savingNewView = false;
                    scope.viewName = {newViewName: ''};

                    scope.startRename = (index, view) => {
                        scope.editingView[index] = true;
                        scope.renameModel[index] = view.name;
                    };
                    scope.confirmRename = (index) => {
                        if (!scope.renameModel[index] || !scope.renameModel[index].trim()) return;
                        scope.onRenameSavedView({index: index, newName: scope.renameModel[index].trim()});
                        scope.editingView[index] = false;
                    };
                    scope.cancelRename = (index) => {
                        scope.editingView[index] = false;
                    };
                    scope.saveNewView = () => {
                        scope.savingNewView = true;
                        scope.viewName.newViewName = '';
                    };
                    scope.confirmNewView = () => {
                        if (!scope.viewName.newViewName.trim()) return;
                        scope.onAddSavedView({
                            name: scope.viewName.newViewName.trim(),
                            collapsedTitles: scope.getCollapsedTitles()
                        });
                        scope.savingNewView = false;
                        scope.viewName.newViewName = '';
                    };
                    scope.cancelNewView = () => {
                        scope.savingNewView = false;
                    };
                    scope.getCollapsedTitles = () =>
                        Object.keys(scope.collapsedHeaders).filter(t => scope.collapsedHeaders[t]);
                    scope.applyView = (view) => {
                        scope.collapsedHeaders = {};
                        (view.collapsedGroupTitles || []).forEach(t => {
                            scope.collapsedHeaders[t] = true;
                        });
                        writeCollapsedToStorage();
                        scope.onApplySavedView({view: view});
                    };
                    scope.confirmDeleteView = (index) => {

                        DoclrModalService.openConfirmModal('Verwijderen', 'Weet je zeker dat je deze weergave wil verwijderen?')
                            .then(() => scope.onDeleteSavedView({index: index}));
                    };
                    scope.isViewActive = (view) => {
                        if (!scope.selectedAgendas || !view.calendarIds) return false;
                        const currentCalUuids = scope.selectedAgendas.map(id => id.split('/').pop()).sort();
                        const viewCalUuids = [...view.calendarIds].sort();
                        const currentResUuids = (scope.selectedResources || []).map(id => id.split('/').pop()).sort();
                        const viewResUuids = [...(view.resourceIds || [])].sort();
                        return currentCalUuids.join(',') === viewCalUuids.join(',') &&
                            currentResUuids.join(',') === viewResUuids.join(',');
                    };
                }
            };
        })
        .directive('slideToggle', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attr) {
                    let initialized = false;
                    scope.$watch(attr.slideToggle, function (collapsed) {
                        if (!initialized) {
                            initialized = true;
                            element.addClass(collapsed ? 'collapse' : 'collapse in');
                            return;
                        }
                        element.collapse(collapsed ? 'hide' : 'show');
                    });
                }
            };
        })
        .directive('resourcelist', function () {
            return {
                restrict: 'A',
                scope: {
                    resources: '=',
                    onResourceClicked: '&',
                    selectedResources: '=',
                    header: '=',
                },
                templateUrl: '/partials/components/utils/resource.list.html',
                replace: true
            };
        })
        .filter('highlight', function () {
            return function (input, searchString) {
                if (!searchString) {
                    return input;
                }

                var escaped = searchString.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
                    .replace(/a/g, '[aáàâä]')
                    .replace(/e/g, '[eéèêë]')
                    .replace(/i/g, '[iíìîï]')
                    .replace(/o/g, '[oóòôö]')
                    .replace(/u/g, '[uúùûü]')
                    .replace(/n/g, '[nñ]')
                    .replace(/c/g, '[cç]');
                return input.replace(new RegExp(escaped, 'gi'), '<span class="highlight">$&</span>');
            };
        })
        .filter('escapehtml', function () {
            //https://github.com/janl/mustache.js/blob/master/mustache.js#L82
            var entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                '\'': '&#39;',
                '/': '&#x2F;'
            };

            function escapeHtml(string) {
                return String(string).replace(/[&<>"'\/]/g, function (s) {
                    return entityMap[s];
                });
            }

            return function (input) {
                return escapeHtml(input);
            };
        })

        .filter('easydate', function ($filter) {
            return function (date) {
                if (!date) {
                    return '';
                } else if (moment(date).isSame(moment(), 'day')) {
                    return doclrVertaal.instant('easydate.today') + $filter('date')(date, ' HH:mm');
                } else if (moment(date).isSame(moment().subtract(1, 'day'), 'day')) {
                    return doclrVertaal.instant('easydate.yesterday') + $filter('date')(date, ' HH:mm');
                } else if (moment(date).isSame(moment(), 'year')) {
                    return $filter('date')(date, 'dd MMM HH:mm');
                } else {
                    return $filter('date')(date, 'dd MMM yyyy HH:mm');
                }
            };
        }).filter('keepOnlyNumbers', function () {
        return function (val) {
            if (val) {
                return val.replace(/[^\d]/g, '');
            }
            return val;
        };


    })

        .filter('easydateUtcToLocal', function () {
            return function (date) {
                try {
                    if (!date) {
                        return '';
                    }
                    const utcDate = moment.utc(date, 'YYYY-MM-DDTHH:mm:ss');
                    const localDate = utcDate.local();

                    if (utcDate.isSame(moment.utc(), 'day')) {
                        return doclrVertaal.instant('easydate.today') + localDate.format(' HH:mm');
                    } else if (utcDate.isSame(moment.utc().subtract(1, 'day'), 'day')) {
                        return doclrVertaal.instant('easydate.yesterday') + localDate.format(' HH:mm');
                    } else if (utcDate.isSame(moment.utc(), 'year')) {
                        return localDate.format('DD MMM HH:mm');
                    } else {
                        return localDate.format('DD MMM YYYY HH:mm');
                    }
                } catch (ex) {
                    return '';
                }
            };
        })
        .directive('doclrSwitch', function ($parse) {
            return {
                restrict: 'A',
                replace: true,
                require: 'ngModel',
                scope: {
                    trueLabel: '@',
                    falseLabel: '@'
                },
                template:
                    '<div role="radio" class="btn-group" role="group">' +
                    '<button type="button" class="btn btn-default" ng-class="{active : model, \'btn-success\' : redGreen && model , \'btn-primary\' : primaryPrimary && model }"  ng-click="setValue(true)">{{ trueLabel ? trueLabel : ("doclr.Yes" | translate) }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{active : !model, \'btn-danger\' : redGreen && !model, \'btn-primary\' : primaryPrimary && !model }"  ng-click="setValue(false)">{{ falseLabel ? falseLabel : ("doclr.No" | translate) }}</button>' +
                    '</div>',

                link: function (scope, element, attrs, ngModelCtrl) {
                    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attrs.ngTrueValue, true);
                    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attrs.ngFalseValue, false);
                    scope.redGreen = 'redGreen' in attrs;
                    scope.primaryPrimary = 'primaryPrimary' in attrs;

                    ngModelCtrl.$formatters.push(function (modelValue) {
                        return angular.equals(modelValue, trueValue);
                    });

                    ngModelCtrl.$parsers.push(function (viewValue) {
                        return viewValue ? trueValue : falseValue;
                    });

                    ngModelCtrl.$viewChangeListeners.push(function () {
                        scope.$eval(attrs.ngChange);
                    });

                    ngModelCtrl.$render = function () {
                        scope.model = ngModelCtrl.$viewValue;
                    };

                    scope.setValue = function (value) {
                        scope.model = value;

                        ngModelCtrl.$setViewValue(scope.model);
                    };
                }
            };
        })
        .directive('doclrToggleIcon', function ($parse) {
            return {
                restrict: 'A',
                replace: true,
                require: 'ngModel',
                scope: {
                    trueIcon: '@',
                    falseIcon: '@',
                    trueTooltip: '=',
                    falseTooltip: '=',
                    trueClass: '@',
                    falseClass: '@',
                },
                templateUrl: '/partials/components/utils/doclr.toggle.icon.html',

                link: function (scope, element, attrs, ngModelCtrl) {
                    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attrs.ngTrueValue, true);
                    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attrs.ngFalseValue, false);
                    scope.redGreen = 'redGreen' in attrs;
                    scope.primaryPrimary = 'primaryPrimary' in attrs;

                    ngModelCtrl.$formatters.push(function (modelValue) {
                        return angular.equals(modelValue, trueValue);
                    });

                    ngModelCtrl.$parsers.push(function (viewValue) {
                        return viewValue ? trueValue : falseValue;
                    });

                    ngModelCtrl.$viewChangeListeners.push(function () {
                        scope.$eval(attrs.ngChange);
                    });

                    ngModelCtrl.$render = function () {
                        scope.model = ngModelCtrl.$viewValue;
                    };

                    scope.setValue = function (value) {
                        scope.model = value;
                        ngModelCtrl.$setViewValue(scope.model);
                    };
                }
            };
        })
        .directive('autofocus', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element) {
                    $timeout(function () {
                        if ($element[0].attributes['autofocus']) { //fix for ng-attr-autofocus also firing this directive
                            $element[0].focus();
                        }
                    });
                }
            };
        })
        .directive('convertToNumber', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function (val) {
                        return parseInt(val, 10);
                    });
                    ngModel.$formatters.push(function (val) {
                        return '' + val;
                    });
                }
            };
        })
        .directive('copyToClipboard', function (notificationService) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    elem.click(function () {
                        if (attrs.copyToClipboard) {
                            var $temp_input = $("<input>");
                            $("body").append($temp_input);
                            $temp_input.val(attrs.copyToClipboard).select();
                            document.execCommand("copy");
                            $temp_input.remove();
                            if (attrs.copyToClipboardNotification) {
                                notificationService.showSuccess(attrs.copyToClipboardNotification);
                            }
                        }
                    });
                }
            };
        })
        .directive('insertAtPosition', ['$rootScope', function ($rootScope) {
            return {
                link: function (scope, element, attrs) {
                    if (attrs.insertAtPosition) {
                        $rootScope.$on(attrs.insertAtPosition, function (e, val) {
                            var domElement = element[0];

                            if (document.selection) {
                                domElement.focus();
                                var sel = document.selection.createRange();
                                sel.text = val;
                                domElement.focus();
                            } else if (domElement.selectionStart || domElement.selectionStart === 0) {
                                var startPos = domElement.selectionStart;
                                var endPos = domElement.selectionEnd;
                                var scrollTop = domElement.scrollTop;
                                domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
                                domElement.focus();
                                domElement.selectionStart = startPos + val.length;
                                domElement.selectionEnd = startPos + val.length;
                                domElement.scrollTop = scrollTop;
                            } else {
                                domElement.value += val;
                                domElement.focus();
                            }
                        });

                    }
                }
            }
        }])
        .factory('groupByKey', function () {
            return function (array, keySelector) {

                let groups = [];
                let groupIndex = [];
                for (const arrayItem of array) {
                    let key = keySelector(arrayItem);
                    if (!groupIndex[key]) {
                        let newGrouping = {
                            key: key,
                            values: []
                        };
                        groupIndex[key] = newGrouping;
                        groups.push(newGrouping);
                    }
                    groupIndex[key].values.push(arrayItem)
                }
                return groups;
            };
        })
        .factory('snorretjeReplace', function () {
            return function (text, replaceDictionary) {

                if (!text) {
                    return text;
                }

                for (const [key, value] of Object.entries(replaceDictionary)) {
                    text = text.replaceAll("{{" + key + "}}", value);
                }
                return text;
            };
        })
        .factory('sortByProperty', function () {
            return function (propertySelector) {
                return (a, b) => applySort(propertySelector, a, b);
            };
        })

        .factory('scrollerService', function () {

            function getPageScroller() {
                return document.scrollingElement || document.documentElement || document.body;
            }


            function getScrollXState(scroller = getPageScroller()) {
                const maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
                const left = scroller.scrollLeft;

                return {
                    left,
                    maxLeft,
                    canLeft: left > 0,
                    canRight: left < maxLeft - 1
                };
            }

            function scrollPageXBy(delta, opts = {}) {
                const scroller = opts.scroller || getPageScroller();
                const behavior = opts.behavior || 'smooth'; // 'auto' or 'smooth'

                const {left, maxLeft} = getScrollXState(scroller);
                const next = Math.min(maxLeft, Math.max(0, left + delta));

                scroller.scrollTo({left: next, top: scroller.scrollTop, behavior});

                return getScrollXState(scroller);
            }

            return {
                scrollPageXBy: scrollPageXBy,
                getPageScroller: getPageScroller,
                getScrollXState: getScrollXState

            }


        });

    function applySort(propertySelector, a, b) {
        let propA = propertySelector(a);
        let propB = propertySelector(b);

        if (!propA) {
            if (propB) {
                return -1
            } else {
                return 0;
            }
        }

        if (!propB) {
            return 1;
        }

        if (propA.localeCompare) {
            return propA.localeCompare(propB);
        }

        if (propA < propB)
            return -1;
        if (propA > propB)
            return 1;
        return 0;
    }

    function datetimestamper() {

        const now = new Date();
        const year = now.getFullYear();
        let month = now.getMonth() + 1;
        let day = now.getDate();
        let hour = now.getHours();
        let minute = now.getMinutes();
        let second = now.getSeconds();
        if (month.toString().length === 1) {
            month = '0' + month;
        }
        if (day.toString().length === 1) {
            day = '0' + day;
        }
        if (hour.toString().length === 1) {
            hour = '0' + hour;
        }
        if (minute.toString().length === 1) {
            minute = '0' + minute;
        }
        if (second.toString().length === 1) {
            second = '0' + second;
        }
        return +year + '-' + month + '-' + day + '_' + hour + '-' + minute + '-' + second;
    }
})();